/*
 * Copyright (c) 2008-present Sonatype, Inc.
 *
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/pro/attributions
 * Sonatype and Sonatype Nexus are trademarks of Sonatype, Inc. Apache Maven is a trademark of the Apache Foundation.
 * M2Eclipse is a trademark of the Eclipse Foundation. All other trademarks are the property of their respective owners.
 */
import {assign} from 'xstate';
import axios from 'axios';
import {ListMachineUtils} from '@sonatype/nexus-ui-plugin';

export default ListMachineUtils.buildListMachine({
  id: 'ReplicationListMachine',
  sortField: 'sourceRepo',
  sortableFields: ['name', 'sourceRepositoryName', 'destinationInstanceUrl', 'destinationRepositoryName']
}).withConfig({
  services: {
    fetchData: () => axios.get('/service/rest/beta/replication/connection')
  }
});
